import styled from 'styled-components'

export const InvisibleInput = styled.input`
  display: none;
`
